import { useEffect, useContext } from 'react'
import { useLocation, usePrevious } from 'react-use'
import { utils } from '@digital-commerce/shared-utils'

import { prop, pipe, reject, head, propEq } from 'ramda'

import localeContext from '../../../contexts/Locale'
import useCart from '../../../hooks/useCart'
import { getCheckoutUrl } from './utils'

const { getTopLevelItems } = utils.cart

const useFulfillment = () => {
  const location = useLocation()
  const { lang } = useContext(localeContext)

  const { cart, updateItemFulfillment, isUpdatingItemFulfillment } = useCart()
  const prevIsUpdatingItemFulfillment = usePrevious(isUpdatingItemFulfillment)
  const _hasShippingFee = (item) => propEq('category', 'MOBILITY_SHIPPING')(item)

  const _getFirstItemId = () =>
    pipe(getTopLevelItems, reject(_hasShippingFee), head, prop('id'))(cart)

  const trigger = (fulfillment) => {
    const itemId = _getFirstItemId(cart)
    updateItemFulfillment({ fulfillment, itemId })
  }
  useEffect(() => {
    if (isUpdatingItemFulfillment === 0 && prevIsUpdatingItemFulfillment === 1) {
      // eslint-disable-next-line no-undef
      window.location.assign(getCheckoutUrl(cart, location.search, lang))
    }
  }, [isUpdatingItemFulfillment])
  return trigger
}

export default useFulfillment
